/** Staff personal-details intake permission strings (mirror backend PermissionCatalog). */
export const StaffPersonalDetailsPermissions = {
  read: 'staff_personal_details_read',
  manage: 'staff_personal_details_manage',
  import: 'staff_personal_details_import',
  access: ['staff_personal_details_read', 'staff_personal_details_manage'] as const,
  /** Supervisors get the bulk upload without the HR list. */
  importAccess: [
    'staff_personal_details_import',
    'staff_personal_details_manage',
  ] as const,
} as const
